import { ROLES, ROLE_GROUPS } from "@/helpers/roles";
export default [
  {
    path: "/stats/sales",
    name: "stats.sales",
    meta: {
      authRequired: true,
      roles: ROLES.ADMIN,
    },
    component: () => import("@/router/views/stats/stats.sales"),
  },
  {
    path: "/stats/reports",
    name: "stats.reports",
    meta: {
      authRequired: true,
      roles: ROLES.ADMIN,
    },
    component: () => import("@/router/views/stats/stats.reports"),
  },
  {
    path: "/stats/reporting",
    name: "stats.reporting",
    meta: {
      authRequired: true,
      roles: ROLES.ADMIN,
    },
    component: () => import("@/router/views/stats/stats.reporting"),
  },
  {
    path: "/stats/products",
    name: "stats.products",
    meta: {
      authRequired: true,
    },
    component: () => import("@/router/views/stats/stats.products"),
  },
  {
    path: "/stats/stock-optimization",
    name: "stats.stock-optimization",
    meta: {
      authRequired: true,
      roles: ROLES.ADMIN,
    },
    component: () => import("@/router/views/stats/stats.stock-optimization"),
  },
  {
    path: "/stats/sales-reporting",
    name: "stats.sales-reporting",
    meta: {
      authRequired: true,
      roles: ROLES.ADMIN,
    },
    component: () => import("@/router/views/stats/stats.sales-reporting"),
  },
];
